/* @ngInject */
function CampaignListCardController ($scope, $state, $rootScope, $q, Utils, $translate, CampaignService, ToastService, UdsModalService, ConfirmationModalService) {
  const getCampaignAccessDialogController = () => $q.when(import('../../dialogs/campaign-access/campaign-access-dialog.controller'))

  $scope.status = {
    type: 'grey',
    label: ''
  }

  const api = {
    getCampaignAccessDialogController,
    _handleCampaignAction,
    _handleSuccess,
    _handleError,
    _getStatusTypeAndLabel,
    _formatDate,
    _areYearsDifferent,
    _calculateFormattedDates
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._getStatusTypeAndLabel($scope.campaign)
    api._calculateFormattedDates($scope.campaign)
  }

  $scope.isCampaignSelected = (selectedCampaigns, campaign) => {
    selectedCampaigns = selectedCampaigns || []
    const foundCampaign = selectedCampaigns.find(selectedCampaign => selectedCampaign?.id === campaign.id)

    return Boolean(foundCampaign)
  }

  $scope.handleCampaignSelection = (campaign) => {
    if (!$scope.selectedCampaigns) {
      $scope.selectedCampaigns = []
    }

    Utils.toggleItemOnArray($scope.selectedCampaigns, campaign)
  }

  $scope.editCampaign = function (campaign) {
    $state.go('campaigns-edit', { id: campaign.id }, { reload: true })
  }

  $scope.archiveCampaign = () => {
    ConfirmationModalService.createModal({
      title: $translate.instant('campaignEdit.archiveConfirm.title'),
      description: $translate.instant('campaignEdit.archiveConfirm.description'),
      buttonCancelText: $translate.instant('campaignEdit.archiveConfirm.cancel'),
      buttonConfirmText: $translate.instant('campaignEdit.archiveConfirm.confirm'),
      onConfirm: () => {
        CampaignService.archiveCampaign($scope.campaign.id)
          .then(() => {
            api._handleSuccess()
          })
          .catch(() => {
            api._handleError()
          })
      }
    })
  }

  $scope.unarchiveCampaign = (campaign) => {
    CampaignService.unarchiveCampaign(campaign.id)
      .then(api._handleSuccess)
      .catch(api._handleError)
  }

  $scope.openCampaignAccessDialog = (campaign) => {
    api.getCampaignAccessDialogController().then(({ CampaignAccessDialogController }) => {
      const campaignAccessDialog = UdsModalService.createModal({
        controller: CampaignAccessDialogController,
        modalName: 'campaignAccessDialog',
        data: {
          campaign
        }
      })

      campaignAccessDialog.open()
    })
  }

  function _handleCampaignAction (action, campaign) {
    switch (action) {
      case 'archive':
        $scope.archiveCampaign(campaign)
        break
      default:
        console.log('Ação desconhecida:', action)
    }
  }

  function _getStatusTypeAndLabel (campaign) {
    if (campaign.isArchived) {
      $scope.status.label = $translate.instant('campaignsModule.status.archived')
      return
    }

    switch (campaign.status) {
      case 'WAITING':
        $scope.status.label = $translate.instant('campaignsModule.status.waiting')
        $scope.status.type = 'yellow'
        break
      case 'IN_PROGRESS':
        $scope.status.label = $translate.instant('campaignsModule.status.inProgress')
        $scope.status.type = 'blue'
        break
      case 'FINISHED':
        $scope.status.label = $translate.instant('campaignsModule.status.finished')
        $scope.status.type = 'green'
        break
      case 'LATE':
        $scope.status.label = $translate.instant('campaignsModule.status.late')
        $scope.status.type = 'red'
        break
      default:
        $scope.status.label = ''
        $scope.status.type = 'grey'
        break
    }
  }

  function _formatDate (dateISO, includeYear) {
    const locale = $rootScope.oUser?.locale || 'en-US'
    const configOptions = { month: 'short', day: 'numeric' }

    if (includeYear) configOptions.year = 'numeric'

    let formattedDate = new Intl.DateTimeFormat(locale, configOptions).format(new Date(dateISO))
    formattedDate = formattedDate.replace(/ de |\./g, ' ')

    return formattedDate
  }

  function _areYearsDifferent (startDate, deliveryDate) {
    const startYear = new Date(startDate).getFullYear()
    const deliveryYear = new Date(deliveryDate).getFullYear()
    return startYear !== deliveryYear
  }

  function _calculateFormattedDates (campaign) {
    const includeYearInStartDate = api._areYearsDifferent(campaign.startDate, campaign.deliveryDate)

    campaign.startDateFormatted = api._formatDate(campaign.startDate, includeYearInStartDate)
    campaign.deliveryDateFormatted = api._formatDate(campaign.deliveryDate, true)
  }

  function _handleSuccess () {
    ToastService.defaultSuccessToast()
    $scope.getAllCampaigns()
  }

  function _handleError () {
    ToastService.defaultErrorToast()
  }
}

export { CampaignListCardController }
